import { FontHinting, full, none, medium, slight } from "@cloudinary/transformation-builder-sdk/qualifiers/fontHinting";
export { FontHinting, full, none, medium, slight };
